export const BodyCommon = ({ children }) => {
  return (
    <div className="relative h-screen">
      <div className="block__ground h-full">{children}</div>
    </div>
  )
}

export default BodyCommon
